import { render, staticRenderFns } from "./OrderListPage.vue?vue&type=template&id=897b1a7e&scoped=true&"
import script from "./OrderListPage.vue?vue&type=script&lang=js&"
export * from "./OrderListPage.vue?vue&type=script&lang=js&"
import style0 from "./OrderListPage.vue?vue&type=style&index=0&id=897b1a7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897b1a7e",
  null
  
)

export default component.exports